import { useNavigate } from 'react-router-dom';
import { userSession } from 'state/session';
import { user } from 'utils/auth/user';
import { voipRtcConnection } from 'utils/ui/rtc';

export const useEndSession = () => {
  const navigate = useNavigate();
  const session = userSession().useState();

  return () => {
    if (user.type === 'customer') {
      if (userSession().voipEnabled && voipRtcConnection) {
        voipRtcConnection.destroy();
      }
      navigate(`/${session.brand}/${session.market}/view/${session.id}/goodbye`);
    }
  };
};
